import { render, staticRenderFns } from "./standByLedgerTable.vue?vue&type=template&id=2b4bc4e4"
import script from "./standByLedgerTable.vue?vue&type=script&lang=js"
export * from "./standByLedgerTable.vue?vue&type=script&lang=js"
import style0 from "./standByLedgerTable.vue?vue&type=style&index=0&id=2b4bc4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports